// src/themes/cyber-chrome.ts
import { Theme } from "./types";

export const cyberChromeTheme: Theme = {
  "background-light": "32 32 32", // #202020 - Dark chromium
  "background-dark": "24 24 24", // #181818 - Deeper chromium
  "card-light": "45 45 45", // #2D2D2D - Metallic gray
  "card-dark": "38 38 38", // #262626 - Darker metallic
  "input-light": "58 58 58", // #3A3A3A - Input gray
  "input-dark": "52 52 52", // #343434 - Darker input
  "border-light": "90 90 90", // #5A5A5A - Chrome border
  "border-dark": "82 82 82", // #525252 - Darker border
  primary: "64 224 208", // #40E0D0 - Turquoise
  "primary-hover": "72 209 204", // #48D1CC - Bright turquoise
  text: "220 220 220", // #DCDCDC - Light chrome
  "text-dark": "200 200 200", // #C8C8C8 - Soft chrome
  "text-secondary": "160 160 160", // #A0A0A0 - Muted chrome
  "text-secondary-dark": "140 140 140", // #8C8C8C - Darker chrome
};
